import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import { AcountingHeading } from './common/AcountingHeading'
import { appendToUrl, focusElemnt, getInt, isEmpty, navigation3 } from '../../common/helper'
import { getCreditTransactionData, getOwnChildBranches, getReportBranchList } from '../../../store/reports/reports_action'
import { useEffect } from 'react'
import * as URL from '../Reports/oldReportsUrls'
import { getBranchConfigOrEwbillinfo, updateAlertError, updateLoader, updateModal } from '../../../store/common/common_action'
import TableViewCreditTransaction from './TableViewCreditTransaction'
import { GetRequest, PostRequest, PostRequestCachedV3 } from '../../common/api'
import { urls } from '../../common/constants'
import ManageColumns from '../../common/ManageColumnsUI'
import { creditTransReportColumn, creditTransReportColumnForBoth, creditTransReportColumnFormattedLRNO, creditTransReportColumnWithNewCommission } from './common/AcountingConstants'
import Alert from '../../common/alert'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../helpers/useTokens'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
import { downloadPDF } from '../Reports/analysisReport/pdfAutotable'

const CreditReport = (props) => {
  const {
    data: { common, reports },
    getOwnChildBranches,
    updateAlertError,
    updateModal,
    updateLoader
  } = props
  const { ownChildBranches1, creditTransactionReportData } = reports
  const { showModal, modalType } = common
  const reportName = 'Branch Credit Limit Transaction'
  const [stateList, setStateList] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selState, setSelState] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [isExpanded, setIsExpanded] = useState(false)
  const [resetFlag, setResetFlag] = useState(false)
  const [resetCity, setResetCity] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const [creditTransTableData, setCreditTransTableData] = useState([])
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: ''
  })

  const [companySettings] = useAtom(companySettingsAtom)
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights } = { ...roleRightsData }
  const [searchParams] = useSearchParams()
  const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports
  const BranchCrlTxnsPortrait = companySettings?.IsBranchCrlTxnsPortrait

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.strCityName = searchParams.get('CTN') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
    AllowBranchInchargeRights = +searchParams.get('AllowBranchInchargeRights') || 0
    isFromUrl = true
  }

  const { intCompanyID, IsAdmin, intBranchID, intCityID, intUserID, strCompanyName, IsBranchAdmin, strBranchName, IsMTPLAdmin } = loginData

  const selectedFields = manageColumn?.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Date', textAlign: 'left' },
    { field: 'toDate', header: 'To  Date', textAlign: 'left' },
    { field: 'company', header: 'Company', textAlign: 'left' },
    { field: 'state', header: 'State', textAlign: 'left' },
    { field: 'city', header: 'City', textAlign: 'left' },
    { field: 'branch', header: 'Branch', textAlign: 'left' },
  ]
  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY') || '',
    toDate: toDate.format('DD-MM-YYYY') || '',
    company: strCompanyName,
    state: selState?.StateName,
    city: selSourceCity?.CityName,
    branch: selSourceBranch?.BranchName,
    dataType: 'entry',
  }
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  useEffect(() => {
    focusElemnt(id.creditTransFromDate)
  }, [])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      let creditTransReportColumnHeader = UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1 ? creditTransReportColumn : UseFormattedLRinReports === 2 ? creditTransReportColumnFormattedLRNO : creditTransReportColumnForBoth
      if (loginData?.intCompanyID === 406) {
        if (BranchCrlTxnsPortrait === 1) {
          creditTransReportColumnWithNewCommission = creditTransReportColumnWithNewCommission.filter((item) => item.isMandatory === true)
        }
        setManageColumn(creditTransReportColumnWithNewCommission)
      } else {
        if (BranchCrlTxnsPortrait === 1) {
          creditTransReportColumnHeader = creditTransReportColumnHeader.filter((item) => item.isMandatory === true)
        }
        setManageColumn(creditTransReportColumnHeader)
      }
    }
  }, [BranchCrlTxnsPortrait])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intUserID: intUserID,
        intCompanyID: intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
      setSelSourceBranch({ BranchName: strBranchName, BranchID: intBranchID })
    }
  }, [intUserID])
  useEffect(() => {
    if (!isEmpty(roleRightsData)) {
      if (AllowViewAllBranchReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin) {
        const obj = {
          intUserID: 0,
          intCompanyID: intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: 0,
          intIsActive: 1,
        }
        PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, true, 24 * 60 * 60).then((res) => {
          if (res.status === 'Success') {
            const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
            setSourceBranchList(filteredList);
          }
        })
      } else if (!AllowViewAllBranchOfCityReport && AllowBranchInchargeRights) {
        const obj = {
          CompanyID: intCompanyID,
          CityID: intCityID,
          UserID: intUserID,
          BranchID: intBranchID,
          Mode: 1,
        }
        GetRequest(urls.getReportBranchList, obj).then((res) => {
          if (res.status == 'Success') {
            setSourceBranchList(res?.Data?.Table)
          }
        })
      } else {
        const obj = {
          intUserID: 0,
          intCompanyID: intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: intCityID,
          intIsActive: 1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
          if (res.status === 'Success') {
            const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
            setSourceBranchList(filteredList);
          }
        })
      }
    }
  }, [roleRightsData])
  useEffect(() => {
    if (creditTransactionReportData.length > 0) {
      const creditTransactionReportUpdatedData = creditTransactionReportData.map((val) => {
        const bkgDateTime = val.BookingDateTime !== ''
          ? `${moment(val.BookingDateTime).format('DD-MMM-YY')}\n${new Date(val.BookingDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
          : 'N/A';
        return {
          ...val,
          LRNO: val.BookingDateTime !== '' ? val.LRNO : 'N/A',
          BookingDateTime: bkgDateTime,
        };
      });
      setCreditTransTableData(creditTransactionReportUpdatedData)
    }
  }, [creditTransactionReportData])
  useEffect(() => {
    if (!isEmpty(ownChildBranches1)) {
      if (ownChildBranches1?.length > 0) {
        const { intBranchCityID, strCityName } = loginData;
        const { stateList } = ownChildBranches1.reduce(
          (acc, val) => {
            const { StateID, StateName } = val
            if (!acc.statesMap.has(StateID)) {
              acc.statesMap.set(StateID, { StateID, StateName })
              acc.stateList.push({ StateID, StateName })
            }
            return acc
          },
          {
            statesMap: new Map(),
            stateList: [],
          }
        )
        setStateList([{ StateName: 'All', StateID: 0 }, ...stateList])
        setSourceCityList([{ CityName: 'All', CityID: 0 }, ...ownChildBranches1])
        const selectedState = ownChildBranches1.find(obj => obj.CityID === intBranchCityID);
        setSelState({
          StateName: selectedState?.StateName || '',
          StateID: selectedState?.StateID || '',
        });
        setSelSourceCity({ CityName: strCityName, CityID: intBranchCityID })
      } else {
        setStateList([])
        setSourceCityList([])
        setSelState('')
        setSelSourceCity('')
      }
    }
  }, [ownChildBranches1])
  useEffect(() => {
    if (!isEmpty(roleRightsData) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          AllowViewAllBranchReport ||
          AllowBranchInchargeRights ||
          IsBranchAdmin ||
          IsMTPLAdmin ||
          IsAdmin
        )
      )
    }
  }, [roleRightsData])
  const handleClick1 = (isPdf = false) => {
    if (selState == '' || selState == ' ') {
      updateAlertError({ show: true, msg: 'Select State', nextId: '' })
    }
    if (selSourceCity == '' || selSourceCity == ' ') {
      updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    }
    if (selSourceBranch == '' || selSourceBranch == ' ') {
      updateAlertError({ show: true, msg: 'Select Branch', nextId: '' })
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'Selected Date Range is More Then One Month', nextId: '' })
    } else {
      const obj = {
        CompanyID: intCompanyID,
        BranchID: selSourceBranch?.BranchID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
      }
      updateLoader(true)
      GetRequest(urls.getCreditTransactionData, obj).then((res) => {
        if (res.status == 'Success') {
          if (res?.Data?.Table?.length === 0) {
            setShowAlert({ show: true, message: 'No Data Found!' })
            return
          }
          updateLoader(false)
          const table = res?.Data?.Table?.map((item, index) => ({
            ...item,
            dataType: 'entry',
            sno: index + 1,
            sourceCityBranch: `${item?.SourceCity}\n${item?.SourceBranch}`,
            destCityBranch: `${item?.DestCity}\n${item?.DestBranch}`,
          }));
          let mainHeaderDetailed = manageColumn?.map((val) => ({
            ...val,
            field: val.field,
            align: val.headerSx.textAlign,
            export: val.exportHead,
            weight: 80,
            width: getInt(val.headerSx.minWidth),
          }))
          let manageColId = loginData?.intCompanyID === 406 ? 'creditTransReportColumnWithNewCommission' : 'creditTransReportColumnHeader'
          let reportPayload = {
            reportName,
            criteriaHeaders: criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: table,
            mainHeader: mainHeaderDetailed,
            isShowManageColumn: true,
            manageColumnID: manageColId
          }
          if (isPdf === true) {
            downloadPDF({
              reportName,
              criteriaHeaders,
              criteriaData: [criteriaData],
              tableData: table,
              visibleColumns: mainHeaderDetailed,
              loginData,
              hideHeader: false
            })
            return
          }
          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        }
        else {
          updateLoader(false)
          setShowAlert({ show: true, message: res?.ErrMessage })
        }
      }).catch((err) => {
        updateLoader(false)
        console.log('Error:', err)
      })
    }
  }
  const handleClick2 = () => {
    let url = URL.creditTransactionReport
    const urlData = URL.creditTransactionReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intBranchID = selSourceBranch?.BranchID
    urlData.strSelBranch = selSourceBranch?.BranchName
    urlData.fromdate = fromDate.format('DD-MMM-YYYY')
    urlData.todate = toDate.format('DD-MMM-YYYY')
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const onSaveColumns = (items) => {
    setManageColumn(items)
    localStorage.setItem(loginData?.intCompanyID === 406 ? 'creditTransReportColumnWithNewCommission' : 'creditTransReportColumnHeader', JSON.stringify(items))    
  }
  const getCityList = () => {
    if (!selState.StateID) {
      return sourceCityList || []
    } else {
      const filteredCities = sourceCityList.filter((state) => state.StateID === selState.StateID)
      return [{ CityName: 'All', CityID: 0 }, ...filteredCities]
    }
  }
  const getBranchList = () => {
    const { CityID } = selSourceCity;
    const { StateID } = selState;
    if (CityID) {
      return sourceBranchList?.filter(branch => branch.CityID === CityID) || [];
    }
    if (StateID) {
      return sourceBranchList?.filter(branch => branch.StateID === StateID) || [];
    }
    return sourceBranchList || [];
  };

  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0]
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <AcountingHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          {!isFromUrl && <>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id={id.selectCompany}
                label={lb.select_company}
                defaultvalue={strCompanyName}
                disabled={true}
                minWidth={isFromUrl ? '100%' : '250px'}
                width={isFromUrl ? '100%' : '300px'}
              />
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                GO
              </Button>
            </Item>
          </>}
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              id={id.creditTransFromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              startDate={'2022-01-01'}
              width='100%'
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              id={id.toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt(disableBtn ? id.creditTransSplitButton : id.stateId)
              }}
              startDate={'2022-01-01'}
              width='100%'
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={'Select State'}
              data={stateList || []}
              defaultvalue={selState?.StateName}
              idKey={`StateID`}
              dataKey={`StateName`}
              onSelect={(val) => {
                setSelState(val)
                setIsExpanded(false)
                setResetCity(true)
              }}
              isObjArr={true}
              width={isFromUrl ? '100%' : '310px'}
              nextId={id.srcCity}
              prevId={id.toDate}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.srcCity}
              label={'Select City'}
              data={getCityList()}
              defaultvalue={selSourceCity?.CityName}
              idKey={`CityID`}
              dataKey={`CityName`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceCity(val)
                setResetCity(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width={isFromUrl ? '100%' : '310px'}
              nextId={id.srcBranch}
              prevId={id.stateId}
              resetFlag={resetCity || resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.srcBranch}
              label={'Select Branch'}
              data={getBranchList()}
              defaultvalue={selSourceBranch?.BranchName}
              idKey={`BranchID`}
              dataKey={`BranchName`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceBranch(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width={isFromUrl ? '100%' : '310px'}
              nextId={id.creditTransSplitButton}
              prevId={id.srcCity}
              resetFlag={resetCity || resetFlag}
              disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={id.creditTransSplitButton}>
              DOWNLOAD PDF
            </Button> :
            <>
              <Item
                sx={sx.itemsx}
                onKeyDown={(e) => navigation3(e, isExpanded ? 'creditTransExcelBtn' : id.creditTransFromDate, () => handleClick1())}
              >
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  id1={id.creditTransSplitButton}
                  prevID={disableBtn ? id.toDate : id.srcBranch}
                  onClick1={handleClick1}
                  onClick2={handleClick2}
                />
              </Item>
              <Item
                sx={{ ...sx.itemsx }}
                onClick={() => {
                  setResetFlag(!resetFlag)
                }}
              >
                <RefreshSvg />
              </Item>
            </>}
        </Box>
      </Item>
      <Item>
        {isExpanded ? (
          <TableViewCreditTransaction
            reportData={creditTransTableData}
            loginData={loginData}
            fromDate={fromDate}
            toDate={toDate}
            company={strCompanyName}
            StateName={selState?.StateName}
            city={selSourceCity?.CityName}
            branch={selSourceBranch?.BranchName}
            updateModal={updateModal}
            columns={manageColumn}
            selectedFields={selectedFields}
            UseFormattedLRinReports={UseFormattedLRinReports}
          />
        ) : (
          ''
        )}
      </Item>
      {showModal && modalType === 'showManageColumnForCreditTrans' && (
        <ManageColumns
          headers={manageColumn}
          onSave={onSaveColumns}
          updateModal={updateModal}
          headTxt={`Columns for Branch Credit Limit Transaction Report`}
        />
      )}
      {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getOwnChildBranches,
  getBranchConfigOrEwbillinfo,
  getReportBranchList,
  getCreditTransactionData,
  updateAlertError,
  updateModal,
  updateLoader,
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditReport)
